import React, { useState } from 'react';
import moment from 'moment';
import { withApollo, useQuery } from 'react-apollo';
import gql from 'graphql-tag'
import { useConfirm } from "material-ui-confirm";
import { Card, Button, Grid, DisplayItem, Modal, ActivityIndicator, TextInput, Switch } from '../generic';
import Mandates from './Mandates'
import { PAYROLL_PAYMENT_TYPES } from '../../variables/paymentTypes'


const CREATE_PERSAL_MANDATE = gql`
  mutation createPersalMandate($productAmount: ProductAmountInput, $persalPayrollNumber: String, $persalEmployeeNumber: String, $persalReservationRef: String, $persalSalaryMonth: String) {
    createPersalMandate(productAmount: $productAmount, persalPayrollNumber: $persalPayrollNumber, persalEmployeeNumber: $persalEmployeeNumber, persalReservationRef: $persalReservationRef, persalSalaryMonth: $persalSalaryMonth) {
      id
      paymentType
      amount
      payDay
      nextDebitDate
      lastRunAt
      isActive
      qlinkPayrollNumber
      qlinkEmployeeNumber
      persalReservationRef
      persalSalaryMonth
    }
  }`

const UPDATE_PERSAL_DEBIT_ORDER = gql`
  mutation updateDebitOrder($id: String!, $input: UpdateDebitOrderInput!) {
    updateDebitOrder(id: $id, input: $input) {
      id
      isActive
      paymentType
      qlinkPayrollNumber
      qlinkEmployeeNumber
      persalReservationRef
      persalSalaryMonth
      payDay
      lastRunAt
      nextDebitDate
      amount
    }
  }`

function QlinkMandate({ debitorder, paymentMethod, productId, productType, amount, updateProduct, paymentDay, mandates, client, disabled = false, allowEdit = true }) {
  const confirm = useConfirm();
  const [showCreate, setShowCreate] = useState(false)
  const [payrollNumber, setPayrollNumber] = useState('')
  const [employeeNumber, setEmployeeNumber] = useState('')
  const [reservationRef, setReservationRef] = useState('')
  const [salaryMonth, setSalaryMonth] = useState('')
  const [showActivity, setShowActivity] = useState(false)

  // The type to display: the existing mandate's type if there is one, otherwise
  // the funeral/product's currently selected payment method.
  const type = (debitorder && debitorder.paymentType) || paymentMethod || 'QLINK'
  const hasMandate = debitorder && PAYROLL_PAYMENT_TYPES.includes(debitorder.paymentType)

  const updateDebitOrder = (input) => {
    setShowActivity(true)

    client.mutate({
      mutation: UPDATE_PERSAL_DEBIT_ORDER,
      variables: { id: debitorder.id, input }
    })
      .then(() => setShowActivity(false))
      .catch((error) => {
        setShowActivity(false)
        console.log('there was an error', error)
      });
  }

  const createMandate = () => {
    let productAmount = { productId, productType: productType === 'OPEN_MARKET' ? 'CREDIT_LIFE' : productType }
    if (productType === "CREDIT_LIFE" || productType === "GROUP_PRODUCT") {
      productAmount.calculateAmount = true
    } else {
      productAmount.amount = amount
    }

    setShowActivity(true)

    client.mutate({
      mutation: CREATE_PERSAL_MANDATE,
      variables: {
        productAmount,
        persalPayrollNumber: payrollNumber,
        persalEmployeeNumber: employeeNumber,
        persalReservationRef: reservationRef,
        persalSalaryMonth: salaryMonth
      }
    })
      .then((result) => {
        setShowActivity(false)
        setPayrollNumber('')
        setEmployeeNumber('')
        setReservationRef('')
        setSalaryMonth('')
        updateProduct({ debitOrderId: result.data.createPersalMandate.id })
      })
      .catch((error) => {
        setShowActivity(false)
        console.log('there was an error', error)
      });
  }

  return (
    <Card>
      <h3>{type} Mandate</h3>
      {hasMandate
        ? <Grid container justifyContent="flex-start" alignItems="center" spacing={1}>
          <DisplayItem label="Type" value={debitorder.paymentType} xs={1} />
          <DisplayItem label="Payroll No" value={debitorder.qlinkPayrollNumber} xs={2} />
          <DisplayItem label="Employee No" value={debitorder.qlinkEmployeeNumber} xs={2} />
          <DisplayItem label="Reservation Ref" value={debitorder.persalReservationRef} xs={2} />
          <DisplayItem label="Salary Month" value={debitorder.persalSalaryMonth} xs={2} />
          <DisplayItem label="Day" value={debitorder.payDay || paymentDay} xs={1} />
          <DisplayItem label="Last Run" value={debitorder.lastRunAt ? moment(debitorder.lastRunAt).format('DD-MM-YYYY hh:mm a') : "Never"} xs={2} />
          <DisplayItem label="Next Run Amount" value={debitorder.isActive ? debitorder.amount : ""} xs={2} />
          <DisplayItem label="Next Run Date" value={debitorder.nextDebitDate ? moment(debitorder.nextDebitDate).format('DD-MM-YYYY') : ""} xs={2} />
          <Grid item xs={1} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
            <span>Is Active</span>
            <Switch value={debitorder.isActive ? true : false}
              disabled={disabled || allowEdit === false}
              onChange={() => updateDebitOrder({ isActive: !debitorder.isActive })} />
          </Grid>
        </Grid>
        : <Grid container justifyContent="flex-start" alignItems="center" spacing={1}>
          <Grid item xs={4}>No {type} debit order found</Grid>
          <Grid item xs={2}>
            <Button disabled={disabled || allowEdit === false} onClick={() => setShowCreate(true)}>New</Button>
          </Grid>
        </Grid>}
      {showActivity && <ActivityIndicator />}

      <Mandates mandates={mandates} />

      <Modal
        title={`Create ${type} Mandate`}
        okText="Create"
        cancelText="Back"
        open={showCreate}
        onClose={() => setShowCreate(false)}
        noButtons
        maxWidth='md'
      >
        <TextInput fullWidth value={payrollNumber} label={`${type} Payroll Number`} placeholder="Payroll Number" id="persalPayrollNumber"
          onChange={e => setPayrollNumber(e.target.value)} />
        <br />
        <TextInput fullWidth value={employeeNumber} label={`${type} Employee Number`} placeholder="Employee Number" id="persalEmployeeNumber"
          onChange={e => setEmployeeNumber(e.target.value)} />
        <br />
        <TextInput fullWidth value={reservationRef} label="Reservation Ref" placeholder="Reservation Ref" id="persalReservationRef"
          onChange={e => setReservationRef(e.target.value)} />
        <br />
        <TextInput fullWidth value={salaryMonth} label="Salary Month" placeholder="Salary Month" id="persalSalaryMonth"
          onChange={e => setSalaryMonth(e.target.value)} />
        <br />
        <br />
        <Grid container spacing={1}>
          <Grid item xs={5}>
            <Button disabled={!payrollNumber || !employeeNumber} onClick={() => {
              setShowCreate(false)
              confirm({
                title: 'Create New Mandate',
                cancellationButtonProps: { variant: 'contained', color: 'default' },
                confirmationButtonProps: { variant: 'contained', color: 'primary' },
                description: `Do you want to create a new ${type} mandate${amount ? ` of R${amount}` : ''}`
              })
                .then(() => createMandate())
                .catch(() => { })
            }}>Create</Button>
            <Button onClick={() => setShowCreate(false)}>Close</Button>
          </Grid>
        </Grid>
      </Modal>
    </Card>
  )
}

export default withApollo(QlinkMandate)
